import React, { Fragment, useState, useEffect } from 'react';
import { Helmet } from 'react-helmet';
import Otazka from './Otazka';
import Data from './Data/Data.js'
import { useStore } from '../../utils/score';


export default function Single() {
 
    const {setActive} = useStore()
    const active = useStore(state => state.hideButton)
    const answeredQuestions = useStore(state => state.answeredQuestions)
    const scoreGold = useStore(state => state.scoreZlato)
    const scoreSilicon = useStore(state => state.scoreKremik) 
    var scoreSingle = scoreGold + scoreSilicon
    var isSingle = true
    

    console.log(setActive)
    console.log(active)
    console.log(isSingle)
    


 
    useEffect(() => {
        localStorage.setItem("EduRAW", JSON.stringify([]))

    },[]) 


     
    return (
        <Fragment>
        <Helmet><title>Eduraw</title></Helmet>
        <div id="home" className="animate__animated animate__fadeIn">
             
            <section className='main-results'>
               
               <div className="header-main">
                
                    <div className="header-gold"> 
                        <div className="gold-avatar">
                            <img className='' src={require('../../img/gold-avatar.png')} alt="alt"/>
                        </div>

                        {/* <div className='gold-points'> */}
                        <h4 alt="alt">Player's points: {scoreSingle}</h4>
                        </div>
                    {/* </div> */}

                    {/* <div className="header-logo"> 
                        <img className='play-logo' src={require('../../img/logo-trans.png')} alt="alt"/>
                    </div> */}

                    {/* <div className="header-silicon"> 

                        <div className="silicon-avatar">
                        <img className='' src={require('../../img/silicon-avatar.png')} alt="alt"/>
                        </div>
                        
                    </div> */}

                </div>
              
                <div className="quiz-container animate__animated animate__zoomIn">

                   <div className='quiz-question'>
                


                        {active.includes("Physics-Si") && active.indexOf("Physics-Si") === active.length -1 && <Otazka data={Data} cardIndex={10} />}
                        {active.includes("Chemistry-Si") && active. indexOf("Chemistry-Si") === active.length -1 && <Otazka data={Data} cardIndex={11} />}
                        {active.includes("Gastronomy-Si") && active. indexOf("Gastronomy-Si") === active.length -1 &&  <Otazka data={Data} cardIndex={12} />}
                        {active.includes("Agriculture-Si") && active. indexOf("Agriculture-Si") === active.length -1 &&  <Otazka data={Data} cardIndex={13} />}
                        {active.includes("Astronomy-Si") && active. indexOf("Astronomy-Si") === active.length -1 && <Otazka data={Data} cardIndex={14} />}
                        {active.includes("Watch-Si") && active. indexOf("Watch-Si") === active.length -1 && <Otazka data={Data} cardIndex={15} />}
                        {active.includes("Personality-Si") && active. indexOf("Personality-Si") === active.length -1 && <Otazka data={Data} cardIndex={16} />}
                        {active.includes("Information Technology-Si") && active. indexOf("Information Technology-Si") === active.length -1 && <Otazka data={Data} cardIndex={17} />}
                        {active.includes("Engineering-Si") && active. indexOf("Engineering-Si") === active.length -1 && <Otazka data={Data} cardIndex={18} />}
                        {active.includes("Geology-Si") && active. indexOf("Geology-Si") === active.length -1 && <Otazka data={Data} cardIndex={19} />}


                   </div>
                   <div className='quiz-silicon'>
                   <div class="otazky-silicon" style={{display:active.includes("Physics-Si") ? "none":"block"}} onClick={() => setActive("Physics-Si")}>
                            <h5>Physics</h5>
                        </div>
                        <div className="otazky-silicon" style={{display:active.includes("Chemistry-Si") ? "none":"block"}} onClick={() => setActive("Chemistry-Si")}>
                            <h5>Chemistry</h5>
                        </div>
                        <div className="otazky-silicon" style={{display:active.includes("Gastronomy-Si") ? "none":"block"}} onClick={() => setActive("Gastronomy-Si")}>
                            <h5>Gastronomy</h5>
                        </div>
                        <div className="otazky-silicon" style={{display:active.includes("Agriculture-Si") ? "none":"block"}} onClick={() => setActive("Agriculture-Si")}>
                            <h5>Agriculture</h5>
                        </div>
                        <div className="otazky-silicon" style={{display:active.includes("Astronomy-Si") ? "none":"block"}} onClick={() => setActive("Astronomy-Si")}>
                            <h5>Astronomy</h5>
                        </div>
                        <div className="otazky-silicon" style={{display:active.includes("Watch-Si") ? "none":"block"}} onClick={() => setActive("Watch-Si")}>
                            <h5>Watch</h5>
                        </div>
                        <div className="otazky-silicon" style={{display:active.includes("Personality-Si") ? "none":"block"}} onClick={() => setActive("Personality-Si")}> 
                            <h5>Personality</h5>
                        </div>
                        <div className="otazky-silicon" style={{display:active.includes("Information Technology-Si") ? "none":"block"}} onClick={() => setActive("Information Technology-Si")}>
                            <h5>Information Technology</h5>
                        </div>
                        <div className="otazky-silicon" style={{display:active.includes("Engineering-Si") ? "none":"block"}} onClick={() => setActive("Engineering-Si")}>
                            <h5>Engineering</h5>
                        </div>
                        <div className="otazky-silicon" style={{display:active.includes("Geology-Si") ? "none":"block"}} onClick={() => setActive("Geology-Si")}>
                            <h5>Geology</h5>
                        </div>
                        
                   </div>
                   
                </div>
            </section> 

            
        </div>   
      

    </Fragment>

    )
}
